import UserInfos from "./UserInfo.view";

export default UserInfos;
